export default __webpack_public_path__ + "static/media/7.95ddc039.jpg";